import React from 'react';
import fedexLogoUrl from '@assets/fedex/fedex-logo.svg?url';

interface ComponentProps {
  /** rendered height in px - the logo keeps its aspect ratio */
  height?: number;
  className?: string;
}

/**
 * Official FedEx logo, required by the FedEx Integrator brand standards on every screen that
 * shows FedEx services or marks (always together with FedexDisclaimer). The asset is the
 * unmodified file from brand.fedex.com - never recreate, recolor or crop it. The SVG carries the
 * brand clear space, so the wordmark itself is roughly half of the rendered height.
 */
const FedexLogo: React.FC<ComponentProps> = ({ height = 32, className }) => (
  <img src={fedexLogoUrl} alt="FedEx" style={{ height, width: 'auto' }} className={className} />
);

export default FedexLogo;
